import React from "react";

import Context from "../../../context/Context";
//import { ModalController } from "../Modal";
import { ModalController } from "../../../common/components/Modal";
import * as assignPrompt from "./assignPrompt";
import * as component from "../../../components/util/component";
import UnitsList from "../Modal/UnitsList";
import * as officePlanUtil from "../../base/officePlanUtil";

import { CalciteP } from "calcite-react/Elements";
import { Container } from "../../styles/Common/selectArea";

export default class SelectUnit extends React.Component {
  constructor(props) {
    super(props);
    this.state = component.newState({});
  }

  componentDidMount() {}

  componentWillUnmount() {
    component.componentWillUnmount(this);
  }

  onSelectionChanged = selected => {
    if (this.props.onSelectionChanged) {
      this.props.onSelectionChanged(selected);
    }
  };

  render() {
    const prompt = assignPrompt.getPrompt(this.props.promptOptions);
    return (
      <Container>
        <CalciteP>{prompt.text}</CalciteP>
        <UnitsList
          handleSelection={this.onSelectionChanged}
          returnGeometry={this.props.returnGeometry}
        />
      </Container>
    );
  }

  static showModal(props) {
    let content, controller, okButton, selected, warningComponent;

    const onOK = obj => {
      if (props && props.onOK) {
        props.onOK(selected);
      }
    };

    const queryAssignments = (featureItem) => {
      return officePlanUtil
        .queryPeopleAssignedToUnit(featureItem)
        .then((result) => {
          return result.length
        })
        .catch((ex) => {
          console.error("Error querying people assigned to unit", ex);
        });
    }

    let selectProps = {
      promptOptions: props && props.promptOptions,
      returnGeometry: props && props.returnGeometry,
      onSelectionChanged: sel => {
        selected = sel;
        if (okButton) {
          if (sel) okButton.enable();
          else okButton.disable();
        }

        if (selected && selected.feature && warningComponent) {
          queryAssignments(selected).then(assignments => {
            const capacity = selected.feature.attributes.CAPACITY
            const peopleToAdd = props.promptOptions.subjectItems.length
            const projectedAssignments = peopleToAdd + assignments
            if (projectedAssignments >= capacity) {
              let i18n = Context.instance.i18n
              let message = i18n.spaceplanner.capacity.atCapacityWarningUnit
              message = message.replace("{people}", peopleToAdd)
              message = peopleToAdd === 1 ? 
                message.replace("{nounType}", i18n.spaceplanner.capacity.captionSingular) :
                message.replace("{nounType}", i18n.spaceplanner.capacity.captionPlural)
              message = message.replace("{capacity}", capacity)
              message = message.replace("{assignments}", assignments)
              message = assignments === 1 ? 
                message.replace("{assignmentNounType}", i18n.spaceplanner.capacity.captionSingular) :
                message.replace("{assignmentNounType}", i18n.spaceplanner.capacity.captionPlural)
              warningComponent.setMessage(message)
            } else {
              warningComponent.setMessage(null)
            }
          })
        }
      } 
    };

    let modalProps = {
      title: props && props.title,
      showOKCancel: true,
      okLabel: Context.instance.i18n.spaceplanner.buttonLabel.assign,
      onOK: onOK,
      dialogStyle: { height: "65vh", width: "35vw" }
    };
    modalProps.onMountOKButton = btn => {
      okButton = btn;
      okButton.disable();
    };
    modalProps.onMountWarning = warning => {
      warningComponent = warning
    }

    content = <SelectUnit {...selectProps} />;
    controller = new ModalController({});
    controller.show(modalProps, content);
  }
}
